import { FirmAlgoliaSearchResult } from "../../components/search/firm"
import { OfferAlgoliaSearchResult } from "../../components/search/offer"
import { AlgoliaSearchResult } from "../../hooks/useAlgoliaSearch"

export function composeOfferAlgoliaResults(results: OfferAlgoliaSearchResult[]): AlgoliaSearchResult[] {
  if (!results || results.length === 0) {
    return []
  }

  return results.map(({
    objectID,
    title,
    url,
    firm,
    office,
    slug,
  }) => {
    const titleArray: string[] = [title]

    if (firm?.name) {
      titleArray.push(firm.name)
    }

    if (office?.city) {
      titleArray.push(office.city)
    }

    const name = titleArray.join(' - ')

    const finalUrl = (firm?.slug && slug) ? `/cabinets/${firm?.slug}/offres/${slug}` : url

    return {
      objectID,
      name,
      type: 'offer' as const,
      url: finalUrl,
      location: office?.city || '',
      logo: firm?.logo?.url,
      highlightResult: {
        name: {
          value: name,
        },
      },
    }
  })
}

export function composeFirmAlgoliaResults(results: FirmAlgoliaSearchResult[]): AlgoliaSearchResult[] {
  if (!results || results.length === 0) {
    return []
  }

  return results.map(({
    objectID,
    name,
    slug,
    city,
    postalCode,
    logo,
  }) => {
    const nameArray: string[] = [name]

    if (city) {
      nameArray.push(city)
    }

    if (postalCode) {
      nameArray.push(postalCode)
    }

    const title = nameArray.join(' - ')

    return {
      objectID,
      name: title,
      type: 'firm' as const,
      url: `/cabinets/${slug}`,
      location: city || '',
      logo: logo?.url,
      highlightResult: {
        name: {
          value: title,
        },
      },
    }
  })
}
